import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked <span className="orange">Questions</span></h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What industries does TekRevol serve?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol serves various industries which includes healthcare, real estate, gaming, ecommerce, and lifestyle.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    How does TekRevol approach real estate solutions?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Our approach emphases on bringing value to end-users and aligning with planned objectives for an exclusive course of action.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    What sets TekRevol's gaming solutions apart?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Our mobile developers follow industry values, creating fully customizable games that redefine industry standards.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    How does TekRevol add power to eCommerce businesses?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>We build impeccable eCommerce solutions that uplift conversion rates and increase the benefits of digitalization.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>
                                    What makes TekRevol a leader in EdTech solutions?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>We integrate modern practices to engineer end-to-end digital solutions, applying the popularity and recompences of e-learning.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;